<template>
  <page :loading="loading">
    <template #content>
      <SubTopBar/>
    <v-breadcrumbs
      :items="bcItems"
      divider=">"
      class="mt-1"
      large
      />
      <v-row class="ml-4">
        <v-col cols="4" class="mb-n5">
          <v-text-field
            ref="name"
            outlined
            dense
            label="Organization name"
            v-model="name"
            required
            :rules="[global.rules.organisation]"
            @keyup.enter="create"
          />
        </v-col>
        <v-col cols="12" class="mb-n5">
          <v-btn :disabled="!isValidName" color="primary" @click="create">Create</v-btn>
          <v-btn text @click="close">Cancel</v-btn> 
        </v-col>
      </v-row>
    </template>
  </page>
</template>

<script>
import Strings from './Strings.js'
const Iam = require('iam')

export default {
  data() {
    return {
      loading: true,
      name: "",
    }
  },
  computed: {
    bcItems: function () {
      return [
        {},
        {
          text: "Organizations",
          disabled: false,
          exact: true,
          to: {name: 'Organizations'}
        },
        {
          text: `${this.$route.meta.bcText}`,
          disabled: false,
          exact: true,
          href: `${this.$route.path}`
        },
      ]},
    isValidName() {
      return /^[a-z0-9-_.]{3,50}$/.test(this.name)
    }
  },
  methods: {
    create: function () {
      if (!this.isValidName) {
        this.$refs.name.focus()
        return
      }
      const newOrg = new Iam.Organization()
      newOrg.globalid = this.name
      newOrg.owners = [this.username]
      this.$api.createNewOrganization(newOrg, this.callBack(
        this.close,
        error => {
          if (error.status == 409) {
            this.alert("error", Strings(this, "duplicate"), undefined, undefined, () => { this.$refs.name.focus() })
          } else {
            this.alert("error", Strings(this, "something_went_wrong"), undefined, undefined, this.close)
          }
        }
      ))
    }
  },
  mounted() {
    this.loading = false
  }
}
</script>